export default {
  startsWith: "Börjar med",
  contains: "Innehåller",
  notContains: "Innehåller inte",
  endsWith: "Slutar med",
  equals: "Lika med",
  notEquals: "Inte lika med",
  noFilter: "Inget filter",
  filter: "Filter",
  lt: "Mindre än",
  lte: "Mindre än eller lika med",
  gt: "Större än",
  gte: "Större än eller lika med",
  dateIs: "Datumet är",
  dateIsNot: "Datumet är inte",
  dateBefore: "Datumet är tidigare än",
  dateAfter: "Datumet är senare än",
  custom: "Anpassad",
  clear: "Rensa",
  apply: "Använd",
  matchAll: "Matcha alla",
  matchAny: "Matcha något",
  addRule: "Lägg till regel",
  removeRule: "Ta bort regel",
  accept: "Ja",
  reject: "Nej",
  choose: "Välj",
  upload: "Ladda upp",
  cancel: "Avbryt",
  close: "Stäng",
  dayNames: [
    "Söndag",
    "Måndag",
    "Tisdag",
    "Onsdag",
    "Torsdag",
    "Fredag",
    "Lördag",
  ],
  dayNamesShort: ["Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör"],
  dayNamesMin: ["Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör"],
  monthNames: [
    "Januari",
    "Februari",
    "Mars",
    "April",
    "Maj",
    "Juni",
    "Juli",
    "Augusti",
    "September",
    "Oktober",
    "November",
    "December",
  ],
  monthNamesShort: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Maj",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dec",
  ],
  today: "Idag",
  weekHeader: "v",
  firstDayOfWeek: 1,
  showMonthAfterYear: false,
  dateFormat: "yy-mm-dd",
  weak: "Svagt",
  medium: "Mellan",
  strong: "Starkt",
  passwordPrompt: "Fyll i lösenord",
  emptyFilterMessage: "Inga tillgängliga rader",
  emptyMessage: "Inga resultat hittades",
  aria: {
    trueLabel: "Sant",
    falseLabel: "Falskt",
    nullLabel: "Ej vald",
    pageLabel: "Sida {page}",
    firstPageLabel: "Första sidan",
    lastPageLabel: "Sista sidan",
    nextPageLabel: "Nästa sida",
    previousPageLabel: "Föregående sida",
    selectLabel: "Markera",
    unselectLabel: "Avmarkera",
    expandLabel: "Expandera",
    collapseLabel: "Fäll ihop",
  },
};
